import PostBaseTemplate from "../PostBaseTemplate";
import TwitterComponent from "./TwitterComponent";

function TwitterWrapper({
  url,
  downloaded_path,
  videoRef,
  muted,
  onManualUnmute,
  onManualMute,
}) {
  if (!url) return <p>Invalid URL</p>;

  return (
    <PostBaseTemplate platform="twitter" url={url}>
      <TwitterComponent
        downloaded_path={downloaded_path}
        muted={muted}
        url={url}
        videoRef={videoRef}
        onManualUnmute={onManualUnmute}
        onManualMute={onManualMute}
      />
    </PostBaseTemplate>
  );
}

export default TwitterWrapper;
